import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'


const initialState = {
    loadMeldungHistoryListStatus: 'idle',
    loadMeldungHistoryListError: undefined as any,
    loadMeldungHistoryListLastParams: undefined,
    createMeldungHistoryStatus: 'idle',
    createMeldungHistoryError: undefined as any,
    updateMeldungHistoryStatus: 'idle',
    updateMeldungHistoryError: undefined as any,
    deleteMeldungHistoryStatus: 'idle',
    deleteMeldungHistoryError: undefined as any,

    meldungHistoryList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false
}
export const loadMeldungHistoryList = createAsyncThunk('meldungHistorySlice/loadMeldungHistoryList', async ({ parentModel, forceReload=false }: any, { rejectWithValue, getState }: any) => {
    const { loadMeldungHistoryListLastParams } = getState().meldungHistorySlice
    const url = `/api/ixweb/nurismeldhist/?action=gte&MIN_MELDUNGID=${parentModel.HDR_ID}&MAX_MELDUNGID=${parentModel.HDR_ID}`

    let _allParams: any = new URLSearchParams(url.split('?')[1])
    _allParams.sort()
    _allParams = _allParams.toString()

    if (_allParams === loadMeldungHistoryListLastParams && !forceReload) {
        return
    }

    const res = await client.get(
        url,
        {
        })

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { data: res.data.data, params: _allParams }
        }
    } else {  // backend response
        return { data: res.data, params: _allParams }
    }
})
export const createMeldungHistory = createAsyncThunk('meldungHistorySlice/createMeldungHistory', async (meldungHistory: any, { rejectWithValue }: any) => {
    const url = `/api/ixweb/nurismeldhist/`


    const res = await client.post(url, prepareData(meldungHistory))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { ...meldungHistory, HDR_ID: res.data.data.id }
        }
    } else {  // backend response
        return res.data
    }
})
export const updateMeldungHistory = createAsyncThunk('meldungHistorySlice/updateMeldungHistory', async (meldungHistory: any, { rejectWithValue }: any) => {
    const url = `/api/ixweb/nurismeldhist/${meldungHistory.HDR_ID}/`


    const res = await client.put(url, prepareData(meldungHistory))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return meldungHistory
        }
    } else {  // backend response
        return res.data
    }
})
export const deleteMeldungHistory = createAsyncThunk('meldungHistorySlice/deleteMeldungHistory', async (id: any, { rejectWithValue }: any) => {
    const url = `/api/ixweb/nurismeldhist/${id}/`


    const res = await client.delete(
        url,
        {
        })

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return id
        }
    } else {  // backend response
        return id
    }
})

const MeldungHistorySlice = createSlice({
    name: 'meldungHistorySlice',
    initialState,
    reducers: {
        resetloadMeldungHistoryListError: (state) => {
            state.loadMeldungHistoryListError = undefined
        },
        resetcreateMeldungHistoryError: (state) => {
            state.createMeldungHistoryError = undefined
        },
        resetupdateMeldungHistoryError: (state) => {
            state.updateMeldungHistoryError = undefined
        },
        resetdeleteMeldungHistoryError: (state) => {
            state.deleteMeldungHistoryError = undefined
        },
        removeFromMeldungHistoryListById: (state, action) => {
            state.meldungHistoryList = state.meldungHistoryList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        }
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungHistoryList.pending, (state) => {
            state.loadMeldungHistoryListStatus = 'pending'
            state.loadMeldungHistoryListError = undefined
        })
        builder.addCase(loadMeldungHistoryList.fulfilled, (state, action) => {
            state.loadMeldungHistoryListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungHistoryListLastParams = action.payload.params

            state.meldungHistoryList = action.payload.data
        })
        builder.addCase(loadMeldungHistoryList.rejected, (state, action) => {
            state.loadMeldungHistoryListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungHistoryListError = action.error.message
            } else {
                state.loadMeldungHistoryListError = action.payload
            }
        })

        builder.addCase(createMeldungHistory.pending, (state) => {
            state.createMeldungHistoryStatus = 'pending'
            state.createMeldungHistoryError = undefined
        })
        builder.addCase(createMeldungHistory.fulfilled, (state, action) => {
            state.createMeldungHistoryStatus = 'idle'


            state.meldungHistoryList = [...state.meldungHistoryList, Array.isArray(action.payload) ? action.payload[0] : action.payload]
        })
        builder.addCase(createMeldungHistory.rejected, (state, action) => {
            state.createMeldungHistoryStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.createMeldungHistoryError = action.error.message
            } else {
                state.createMeldungHistoryError = action.payload
            }
        })

        builder.addCase(updateMeldungHistory.pending, (state) => {
            state.updateMeldungHistoryStatus = 'pending'
            state.updateMeldungHistoryError = undefined
        })
        builder.addCase(updateMeldungHistory.fulfilled, (state, action) => {
            state.updateMeldungHistoryStatus = 'idle'


            let updatedItems = Array.isArray(action.payload) ? action.payload : [action.payload]
            for (let updatedItem of updatedItems) {
                const i = state.meldungHistoryList.findIndex((x: any) => x.HDR_ID === updatedItem.HDR_ID)
                if (i === -1) { state.meldungHistoryList.push(updatedItem) }
                else { state.meldungHistoryList[i] = { ...state.meldungHistoryList[i], ...updatedItem } }
            }
        })
        builder.addCase(updateMeldungHistory.rejected, (state, action) => {
            state.updateMeldungHistoryStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.updateMeldungHistoryError = action.error.message
            } else {
                state.updateMeldungHistoryError = action.payload
            }
        })

        builder.addCase(deleteMeldungHistory.pending, (state) => {
            state.deleteMeldungHistoryStatus = 'pending'
            state.deleteMeldungHistoryError = undefined
        })
        builder.addCase(deleteMeldungHistory.fulfilled, (state, action) => {
            state.deleteMeldungHistoryStatus = 'idle'


            if (Array.isArray(action.payload)) {
                state.meldungHistoryList = state.meldungHistoryList.filter((x: any) => !action.payload.includes(x.HDR_ID))
            } else {
                state.meldungHistoryList = state.meldungHistoryList.filter((x: any) => x.HDR_ID !== action.payload)
            }
        })
        builder.addCase(deleteMeldungHistory.rejected, (state, action) => {
            state.deleteMeldungHistoryStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungHistoryError = action.error.message
            } else {
                state.deleteMeldungHistoryError = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungHistoryListError,
    resetcreateMeldungHistoryError,
    resetupdateMeldungHistoryError,
    resetdeleteMeldungHistoryError,
    removeFromMeldungHistoryListById,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB
} = MeldungHistorySlice.actions
export default MeldungHistorySlice.reducer
